import "./Roofing.module.css";
import Navigation from "@/reusable_sections/Header";
import RoofingHero from "./sections/RoofingHero";
import RoofingSystems from "./sections/RoofingSystems";
import MetalRoofingBenefits from "./sections/MetalRoofingBenefits";
import Inquiry from "./sections/Inquiry";
import Trust from "./sections/Trust";
import ProjectGallery from "./sections/ProjectGallery";
import Footer from "@/reusable_sections/Footer";
export default function RoofingPage() {
  return <div>
      <Navigation />
      <RoofingHero />
      <RoofingSystems />
      <MetalRoofingBenefits />
      <Inquiry />
      <Trust />
      <ProjectGallery />
      <Footer />
    </div>;
}